var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFarms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 138.154,
    height: 143,
    viewBox: "0 0 138.154 143",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1961",
    d: "M73.937 97.259V67.697c6.863-.466 19.191-2.515 27.668-10.993 12.111-12.111 11.148-31.922 11.117-32.761a4.859 4.859 0 0 0-4.565-4.565c-.838-.062-20.65-.994-32.73 11.086a30.271 30.271 0 0 0-3.416 4.1c-1.77-7.111-5.093-15.061-11.3-21.271C46.271-1.147 22.516.002 21.522.033a4.859 4.859 0 0 0-4.571 4.564c-.062.994-1.18 24.749 13.26 39.189C40.8 54.375 56.357 56.58 64.338 56.986v40.275a41.292 41.292 0 0 1 4.813-.279c1.584.031 3.2.124 4.782.279Z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 75.056)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 147",
    cx: 33.972,
    cy: 33.972,
    r: 33.972,
    transform: "translate(35.773)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 148",
    cx: 33.972,
    cy: 33.972,
    r: 33.972,
    transform: "translate(70.21)",
    fill: "#39beec"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 149",
    cx: 33.972,
    cy: 33.972,
    r: 33.972,
    fill: "#1b60a3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarms);
export default __webpack_public_path__ + "static/media/Farms.cbbbeb64c248da2c094c283c599261bb.svg";
export { ForwardRef as ReactComponent };